module.exports = __webpack_public_path__ + "static/media/card.96da3e7a.wav";